import { render, staticRenderFns } from "./UserPopUp.vue?vue&type=template&id=caf39f8e&scoped=true"
import script from "./UserPopUp.vue?vue&type=script&lang=js"
export * from "./UserPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf39f8e",
  null
  
)

export default component.exports